<section id="cd-timeline" class="cd-container" [dir]="textDir">
  <!--  <div class="v-line"></div>  -->
    <div [ngClass]="textDir=='ltr'?'padL80':''">
        <ul *ngFor="let item of this.ctlSteps; let i=index">
            <li *ngIf="activestep!=-1" [ngClass]="{'active': i==(activestep-1), 'done': i < (activestep-1), 'notdone': i > (activestep-1)}"><a [ngClass]="{'active': i==(activestep-1), 'done': i < (activestep-1), 'notdone': i > (activestep-1)}">{{i+1}}. {{item| translate}}</a></li>
            <li *ngIf="activestep==-1" [ngClass]="{'alldone': (i+1)}"><a [ngClass]="{'alldone':(i+1)}" style="color: #666666 !important;">{{i+1}}) {{item | translate}}</a></li>
        </ul>
    </div>

    <!-- <div class="wiz">
        <div class="v-line"></div>
        <div class="step" *ngFor="let item of this.ctlSteps; let i=index">
          <span *ngIf="activestep!=-1" [ngClass]="{'active': i==(activestep-1), 'done': i < (activestep-1), 'notdone': i > (activestep-1)}"><a [ngClass]="{'active': i==(activestep-1), 'done': i < (activestep-1), 'notdone': i > (activestep-1)}">{{i+1}}. {{item}}</a></span>
          <span *ngIf="activestep==-1" [ngClass]="{'alldone': (i+1)}"><a [ngClass]="{'alldone':(i+1)}" style="color: #666666 !important;">{{i+1}}) {{item}}</a></span>

        </div>
        
      </div> -->

</section>
